module.exports = __webpack_public_path__ + "static/media/forest.37b4f7fa.jpg";